<template>
  <div class="relative overflow-hidden">
    <div class="max-h-[448px] h-full min-h-[150px] z-[1] relative flex">
      <Skeleton
        v-if="loading"
        v-bind="$attrs"
        class="mx-auto object-cover object-center aspect-[7/2] min-w-0 w-full !rounded-none"
        :aspect="7 / 2"
        :class="{
          'blur-md scale-[2] object-[center_20%]': blur,
          'max-w-[1568px]': !blur,
        }"
      />
      <AsyncImage
        v-else
        v-bind="$attrs"
        class="mx-auto object-cover object-center aspect-[7/2] min-w-0 w-full !rounded-none"
        :aspect="7 / 2"
        :class="{
          'blur-md scale-[2] object-[center_20%]': blur,
          'max-w-[1568px]': !blur,
          'bg-neutral-200 dark:bg-neutral-800': !/\.(png|gif|apng)$/i.test(
            src ?? '',
          ),
        }"
        :src="src || fallbackBanner"
        :alt="alt || 'page banner'"
      />
    </div>
    <div class="bg-filler"></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  src?: string;
  alt?: string;
  blur?: boolean;
  loading?: boolean;
}>();

const fallbackBanner = getAbsoluteAssetLink("nami/banner/great-wave.png");

const bgBanner = computed(() =>
  props.blur || props.loading ? "none" : `url(${props.src ?? fallbackBanner})`,
);
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<style scoped lang="postcss">
.bg-filler {
  z-index: 0;
  @apply absolute -inset-8;

  &:after {
    content: "";
    z-index: 0;
    filter: blur(24px) brightness(50%);
    background-image: v-bind(bgBanner);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    @apply inset-0 block absolute bg-neutral-200 dark:bg-neutral-800;
  }
}
</style>
